import { Component } from '@angular/core';

@Component({
  selector: 'app-dapps',
  templateUrl: './dapps.component.html',
  styleUrls: ['./dapps.component.scss']
})
export class DappsComponent {

}
